import React from 'react'
import styles from './AuthPageShell.module.scss'

interface AuthPageShellProps {
  children: React.ReactNode
  className?: never
}

export const AuthPageShell: React.FC<AuthPageShellProps> = ({ children }) => (
  <div className={styles.shell}>
    <div className={styles.container}>
      {children}
    </div>
  </div>
)
